import React, {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import common from "../../../translations/it/common.json";
import Button from "../../../components/Button/Button";
import Table from "../../../components/table/Table";
import style from "../../sportelli/ElencoSportelli.module.css";
import {useHistory} from "react-router";
import ModificaSportello from "../InserimentoModificaSportello/ModificaSportello";
import ModaleOrari from "../OrariSportello/ModaleOrari";
import SportelliService from "../../../services/SportelliService";
import Autocomplete from "../../../components/Autocomplete/Autocomplete";
import Spinner from "../../../components/spinner/Spinner";


function RicercaSportelli(props) {

    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))
    const [state, setState] = useState({comune:""})
    const [flagTableCercaSportelli, setflagTableCercaSportelli] = useState(false)
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "comune ->> 'descrizione'", order: "asc", paginazione: true})
    const [rows, setRows] = useState([])
    const [modalBodyModifica,setModalBodyModifica] = useState(null)
    const history = useHistory()
    const [showSpinner, setShowSpinner] = useState(false)
    const [modalBodyOrari,setModalBodyOrari] = useState(null)
    const cols = [
        {name: "Comune", key: "comune", typeSort: "ASC"},
        {name: "Indirizzo", key: "indirizzo", typeSort: "ASC"},
        {name: "Referente", key: "referente", typeSort: "ASC"},
        {name: "Telefono", key: "telefono", typeSort: "ASC"},
        {name: "Email", key: "email", typeSort: "ASC"},
        {type: "button", key: "id", onClick:onClickButtonVediOrari,typeButton:"White",text:"Vedi Orari",className:style.buttonTable},
        {type: "button", key: "id", onClick:onClickButtonModifica,typeButton:"White",text:"Modifica",className:style.buttonTable,check:"checkSportello"}
    ]

    useEffect(() => {
        getSportelli()
    }, [pagination.page,pagination.sort,pagination.order])

    function getSportelli(flagRicerca) {
        setShowSpinner(true)
        let params = {...pagination}
        params.comune = state.comune.descrizione
        SportelliService.getSportelli(params).then(res => {
            history.push({
                sportelli:res.data.content
            })
            let newPagination = {...pagination}
            newPagination.totalPages = res.data.totalPages
            newPagination.totalElements = res.data.totalElements
            let newRows = JSON.parse(JSON.stringify(res.data.content))
            newRows.forEach(sportello => {
                sportello.comune = sportello.comune.descrizione
                sportello.orari = sportello.id
            })
            setRows(newRows)
            setPagination(newPagination)
            if(flagRicerca){
                setflagTableCercaSportelli(true)
            }
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Sportelli: " + reason)
            setRows([])
            setShowSpinner(false)
        })
    }

    function onClickCercaSportelli() {
        getSportelli(true)
    }

    function onClickButtonModifica(idSportello){
        history.location.sportelli.forEach(sportello => {
            if(sportello.id === idSportello){
                setModalBodyModifica(<ModificaSportello state={sportello} getSportelli={props.getSportelli}/>)
            }
        })
        document.getElementById("modificaSportelloRicerca").click();
    }

    function onClickButtonVediOrari(idSportello){
        history.location.sportelli.forEach(sportello => {
            if(sportello.id === idSportello){
                let sportelloConOrari = {
                    nomeSportello: "Sportello " + sportello.comune.descrizione + ", " + sportello.indirizzo,
                    orari : sportello.orari,
                    appuntamento:sportello.appuntamento,
                    note:sportello.note
                }
                setModalBodyOrari(<ModaleOrari sportelloConOrari={sportelloConOrari}/>)
            }
        })
        document.getElementById("OrariRicerca").click();
    }

    function onChange(id,value) {
        let newState = {...state}
        newState[id] = value
        setState(newState)
    }

    return (
        <div className={" pl-4 "} style={{marginTop: "50px"}}>
            <Spinner show={showSpinner}/>
            <div className={"row"}>
                <div className="col-10">
                    <p style={{fontWeight: "bold", fontSize: "20px"}}>{common.RicercaSportello.titolo}</p>
                </div>
                <div className="col-2">
                    <p style={{fontWeight: "bold", fontSize: "16px", color:"red"}}>Campo obbligatorio*</p>
                </div>
            </div>
            <Row>
                <div className={"col-10"}>
                    <Row>
                        <div className={"col-7"}>
                            <span style={{fontWeight:"bold"}}>Comune<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                            <Autocomplete
                                id={"comune"}
                                ariaLabel={"Comune (obbligatorio)"}
                                onChange={onChange}
                                placeholder={"Comune"}
                                suggestions={comuni}
                                value={state.comune}
                            />
                        </div>
                    </Row>
                </div>
                <div className={"col-1"} >
                    <Button
                        id={"CercaSportello"}
                        onClick={onClickCercaSportelli}
                        typeButton={"Blue"}
                        text={"Cerca"}
                        disabled={!state || !state.comune || !state.comune.descrizione}
                        style={{height: "45px", width: "100px",marginTop:"27px"}}
                    />
                </div>
            </Row>

            <div className="col-3">
                <Button
                    id={"modificaSportelloRicerca"}
                    typeButton={"Blue"}
                    style={{display: "none"}}
                    dataTarget={"modalModificaSportelloRicerca"}
                    dataToggle={"modal"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    body={modalBodyModifica}
                    header={"Modifica Sportello"}
                />
            </div>

            <div className="col-3 pt-3">
                <Button
                    id={"OrariRicerca"}
                    typeButton={"Blue"}
                    style={{display:"none"}}
                    dataTarget={"modaleOrariRicerca"}
                    dataToggle={"modal"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    body={modalBodyOrari}
                    header={"Orari Sportello"}
                />
            </div>

            {flagTableCercaSportelli &&
            <div>
                <div className={" pt-2 "}>
                    <hr style={{border: "0.5px solid grey"}}/>
                </div>
                <p style={{fontWeight: "bold", color: "grey", fontSize: "25px"}}>Risultati</p>
                <Table
                    cols={cols}
                    rows={rows}
                    id={"tabellaProva"}
                />
            </div>}
        </div>
    );

}

export default RicercaSportelli;
